<template>
    <div style="background-color: #f2f2f2;height: 100%;" class="berth">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            床位列表
        </div>
        <div style="padding: 20px;">

            <div class="BerthPage">

                <el-row> 
                    <div style="float:right">
                        <el-cascader
                            v-model="roomCodeList"
                            placeholder="请选择房间"
                            :options="options"
                            filterable
                            clearable
                            @change="handleChange" style="margin:0 10px;float:left">
                        </el-cascader>
                        <el-select
                            v-model="status"
                                style="margin:0 5px;width:200px">
                            <el-option
                                v-for="item in statusValue"
                                :key="item.val"
                                :label="item.name"
                                :value="item.val">
                            </el-option>
                        </el-select>
                        <el-input  placeholder="请输入床号" v-model="number" clearable  style="margin:0 10px;width:200px"></el-input>
                        <el-button style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
                    </div>
                </el-row>
                
                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>

                    <el-table v-loading="tableload" :data="tableData" :height="th" border style="width: 100%;"  highlight-current-row @row-click='rowClick'>

                        <el-table-column prop="roomNumber" label="房间号"></el-table-column>

                        <el-table-column prop="number" label="床位"></el-table-column>

                        <el-table-column prop="building.name" label="楼宇名称"></el-table-column>

                        <el-table-column
                                prop="Status"
                                :formatter="statusTitle"
                                label="状态">
                        </el-table-column>

                    </el-table>

                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>


                </template>
            </div>

        </div>


    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    import {getStaffCode} from "@/utils/auth";

    export default {
        name: "Role",
        data(){
            return{
                tableload:false,
                disabledEdit:true,
                showModalAdd:false,
                showModalEdit:false,
                selectInfo:'',
                tableData:null,
                totalItems: 0,
                pageSize:20,
                statusValue:[{
                    val:-1,
                    name:'全部'
                },{
                    val:0,
                    name:'未住'
                },{
                    val:1,
                    name:'已预约'
                },{
                    val:2,
                    name:'已住'
                },{
                    val:11,
                    name:'禁用'
                }],
                roomCodeList:[],
                currentPage:1,
                roomCode:'00000000-0000-0000-0000-000000000000',
                number:'',
                status:-1,
                th:0,
                options:[]
            }
        },
        created(){
            this.getList();
            this.init();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
            },
        },
        methods:{
            init:function(){
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Room/ListRoom",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then(
                    (response) => {
                        if (response.data.error == 0) {
                            var datas= response.data.data;
                            var JSONData=JSON.stringify(datas);
                            JSONData=JSONData.replace(/listRoomDTO/g,'children');
                            JSONData=JSONData.replace(/name/g,'label');
                            JSONData=JSONData.replace(/roomCode/g,'value');
                            JSONData=JSONData.replace(/number/g,'label');
                            this.options = JSON.parse(JSONData);
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },
            handleClear(){
                this.roomCode='00000000-0000-0000-0000-000000000000';
                console.log(this.roomCode)
            },
            handleChange(value) {
                if(value.length==0){
                    this.roomCode='00000000-0000-0000-0000-000000000000';
                }else{
                    this.roomCode=value[1];
                }
                console.log(this.roomCode);
            },
            handleEdit() {
                this.$refs.myEdit.init(this.selectInfo);
                this.showModalEdit = !this.showModalEdit;
            },
            toggleModalAdd:function(){
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init();
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },
            toggleModalEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },
            closeEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },

            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },

            getList(){
                this.tableload=true
                var numbers=0;
                if(this.number){
                    numbers=this.number;
                }
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Berth/Page",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        number:numbers,
                        roomCode:this.roomCode,
                        status:this.status,
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                        this.tableload=false
                        this.disabledEdit=true
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            statusTitle(row){
                const statusValue=this.statusValue
                for(var i in statusValue){
                    if(statusValue[i].val==row.status){
                        return statusValue[i].name
                    }
                }   
            },
             roomTypeTitle(row){
                if(row.roomType == 1){
                    return "单人间";
                }
                if(row.roomType == 2){
                    return "双人间";
                }
            },
            rowClick(row){
                this.disabledEdit=true
                this.selectInfo=row
                if(row.status==0||row.status==11){
                    this.disabledEdit=false
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .BerthPage{
        .el-button{
            transform: translate(-1px,0);
        }
    }
    .berth /deep/ .el-table__body tr.current-row>td {
        background: rgb(102, 177, 255);
        color:#fff;
    }
</style>
